import { createReducer } from '@reduxjs/toolkit'
import { SET_EVENT_FILTER, SET_EVENT_RED_STATUS, SET_EVENTS } from './actions'
import { SUCCESS, REQUEST, FAILURE } from '../../constants/statuses'

const initialState = {
  events: [],
  pagination: {
    page: 1,
    perPage: 10,
    amount: 2
  },
  isLoading: false,
  isError: false,
  filter: null
}

export const eventsReducer = createReducer(initialState, {
  [SET_EVENTS[SUCCESS]]: (state, action) => {
    state.events = action.payload.data.events
    state.pagination.amount = action.payload.data.amount
    state.pagination.page = action.payload.paging.page
    if (action.payload.paging.count !== 9999) {
      state.pagination.perPage = action.payload.paging.count
    }
    state.isLoading = false
  },

  [SET_EVENTS[REQUEST]]: (state, action) => {
    state.isError = false
    state.isLoading = true
  },

  [SET_EVENTS[FAILURE]]: (state, action) => {
    state.isLoading = false
    state.isError = true
  },

  [SET_EVENT_FILTER]: (state, action) => {
    console.log('action', action)

    state.pagination.page = 1

    state.filter = action.payload
  },

  [SET_EVENT_RED_STATUS]: (state, action) => {
    state.events = state.events.map((item) => {
      if (item.id === action.payload.id && item.status !== 'pending') {
        return {
          ...item,
          staging: {
            ...item.staging,
            [item.stage]: {
              ...item.staging[item.stage],
              success: false
            }
          }
        }
      }
      return item
    })
  }
})
